import useUserConfiguration from '~/hooks/useUserConfiguration';

export default function useIsPowerSeller(): boolean {
  const { data: user } = useUserConfiguration();
  return user?.power_seller || false;
}
